import { render } from "./ProfileOnboarding.vue?vue&type=template&id=5e9d9118&scoped=true"
import script from "./ProfileOnboarding.vue?vue&type=script&lang=js"
export * from "./ProfileOnboarding.vue?vue&type=script&lang=js"

import "./ProfileOnboarding.vue?vue&type=style&index=0&id=5e9d9118&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9d9118"]])

export default __exports__